import { Container, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { AdDetailDto, AdProjectPhotoDto } from "../../../api/psc";
import { EmptyListMessage, PageHeader } from "../../../components/exports";
import AdProjectItem from "./AdProjectItem";

export default function AdDetailList(props: {
    ad: AdDetailDto;
    region: number;
}) {
    const [items, setItems] = useState<AdProjectPhotoDto[]>([]);

    useEffect(() => {
        const projectPhotos = props.ad.regions
            .filter((i) => props.region === 0 || i.region.id === props.region)
            .map((r) => r.projectPhotos)
            .reduce((i, j) => i.concat(j), []);
        setItems(projectPhotos);
    }, [props.region]);

    return (
        <Container maxWidth="xl" sx={{ pt: 8 }}>
            <PageHeader title="لیست تصاویر پروژه ها" />

            {items.length === 0 && (
                <EmptyListMessage message="موردی یافت نشد" />
            )}

            <Grid container spacing={2}>
                {items.map((i) => {
                    return (
                        <Grid
                            item
                            key={i.projectHashId}
                            xs={12}
                            sm={12}
                            md={6}
                            lg={4}
                            xl={3}
                        >
                            <AdProjectItem item={i} />
                        </Grid>
                    );
                })}
            </Grid>
        </Container>
    );
}
